export enum UserRole {
  Admin = 1,
  Editor,
  Base,
}
